import Vue from 'vue'
import App from './App.vue'
import router from './router'
import echarts from 'echarts'
import './plugins/axios'
import apiUrl from '@/assets/api.js';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en'
import svgicon from '@/assets/svg.js';
import axios from 'axios'
import clipboard from 'clipboard';
import QS from 'qs'
import store from './store'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import {calculation} from '@/assets/calculation.js' 
import {axoisfix} from '@/assets/calculation.js' 
import Situationall from './components/selectsearch/index.js'
import Situationall2 from './components/selectsearch/index2.js'
import '@/css/newant.scss'
import inaxios  from '@/assets/axiosConfig.js'
import big5 from'@/langage/big5.js'
import eng from'@/langage/eng.js'
// import { VariableSizeGrid as Grid } from 'react-window'
import htmlToPdf  from '@/utils/htmlToPdf.js'
import Print from '@/utils/print'
import '@/utils/drag'
import 'element-ui/lib/theme-chalk/index.css';
import moment from 'moment'

Vue.use(Print)
inaxios()
Vue.prototype.$moment = moment
Vue.prototype.$svg = svgicon
Vue.prototype.$big5 = big5
Vue.prototype.$eng = eng
Vue.prototype.qs = QS
Vue.prototype.$echarts = echarts
Vue.prototype.$ajax = axios
Vue.prototype.$clipboard = clipboard;
Vue.prototype.$api = apiUrl
Vue.prototype.$calculation = calculation
Vue.prototype.$axoisfix = axoisfix
Vue.use(htmlToPdf)
Vue.use(Antd)
Vue.use(Situationall)
Vue.use(Situationall2)
Vue.use(ElementUI);
axios.defaults.withCredentials = true
Vue.config.productionTip = false


new Vue({
  router,
  axios,
  store,
  render: h => h(App),
  mounted () {
    window.addEventListener('unload', this.saveState)
    window.addEventListener("load", () => {
      sessionStorage.clear();
    });
	// window.history.pushState(null,null,document.URL);
	// window.addEventListener('popstate',()=>{
	// 	console.log('111',location.href)
	// 	// alert('22222222222222')
	// },false)
  },
  methods: {
    saveState () {
      sessionStorage.setItem('state', JSON.stringify(this.$store.state));
    }
  }
}).$mount('#app')

